import React from 'react';
import { Link } from 'react-router-dom';

const Hero: React.FC = () => {
  return (
    <div className="hero">
      <div className="container hero__container">
        <div className="hero__content">
          <h1 className="hero__title">
            <small>Try anime</small>
            <span>tattoos on your body</span>
          </h1>
          <div className="hero__info">
            Upload your photo.<br />
            Try Naruto, One Piece, Hunter x Hunter tattoos instantly.
          </div>
          <a className="btn hero__btn" href="/editor" data-discover="true">Try now — it's free</a>
        </div>
        <div className="hero__img">
          <img src="/img/character_3.png" alt="Anime character" />
        </div>
      </div>
    </div>
  );
};

export default Hero;
